import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import { formatNumberToSquareString } from './formatUtils';

export const detectDevice = (): boolean => {
  if (!window) return null;

  return Boolean(
    window.navigator.userAgent.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i)
  );
};

export const getItemSquare = ({
  square,
  usableSquare,
  isShowSquareConfig = false,
}: {
  square?: number;
  usableSquare?: number;
  isShowSquareConfig?: boolean;
}): string => {
  let value: number;
  if (isShowSquareConfig) {
    value = square;
  } else if (!isShowSquareConfig) {
    value = usableSquare || square;
  }

  if (!value || Number.isNaN(value)) return null;

  return formatNumberToSquareString(value);
};

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  // disable days of the past
  return current && current < moment().subtract(1, 'day');
};
